import { render, staticRenderFns } from "./PrimeiraConsultaProgramada.vue?vue&type=template&id=37ce298f"
import script from "./PrimeiraConsultaProgramada.vue?vue&type=script&lang=js"
export * from "./PrimeiraConsultaProgramada.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports